import { pipe } from 'fp-ts/lib/function';
import * as A from 'fp-ts/lib/Array';
import * as O from 'fp-ts/lib/Option';
import { useSetter, useGetter, plugin } from '../slots';
import { takeCursorData } from '../Input';
import { BOTTOM_CURSOR } from '../Cursor';


const getCursor = (x: Record<string, any> | null, data: Record<string, any>[]) => 
    pipe(
        x,
        O.fromNullable,
        O.chain(x => pipe(
            data,
            A.findIndex(el => x.id === el.id),
        )),
        O.fold(
            () => BOTTOM_CURSOR,
            (x) => x,
        ),
    );

const Plugin = plugin('setter', null)(() => {
    const select =             useGetter('select');
    const service =            useGetter('service');
    const dropdownController = useGetter('dropdown');
    const dropdownTarget =     useGetter('dropdownTarget');
    const target =             useGetter('target');
    const cursorController =   useGetter('cursor');

    const batch = () => {
        console.log('!!!');
        const cursorPosition = cursorController.get();
        const data = dropdownTarget.getMutableData();
        const value = takeCursorData(target.getValue(), cursorPosition, data);

        service.onSelect(value, service.name);
        target.change(value);
        dropdownController.close();
        setTimeout(() => {
            target.inactive();
        }, 1);
    };

    const reset = () => {
        const x = target.getStartValue();
        target.change(x);
        cursorController.set(getCursor(x, dropdownTarget.getData()))
        select.off();
    };

    useSetter('select', {
        batch,
        reset,
    });

    return null;
});

export default Plugin;
